import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { isSupabaseConfigured } from './lib/supabase';
import Layout from './components/Layout';
import Spinner from './components/Spinner';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import Waitlist from './pages/Waitlist';
import Practices from './pages/Practices';
import PracticeEdit from './pages/PracticeEdit';
import NotAuthorized from './pages/NotAuthorized';

export default function App() {
  const location = useLocation();
  const auth = useAuth();

  if (!isSupabaseConfigured) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center p-3">
        <div className="alert alert-danger mb-0">
          Faltam VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY em apps/admin/.env
        </div>
      </div>
    );
  }

  if (location.pathname === '/auth/callback') {
    return <AuthCallback />;
  }

  // Loading inicial — sessão ainda não conhecida
  if (auth.status === 'loading') {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <Spinner label="Verificando sessão…" />
      </div>
    );
  }

  // /auth/callback fica disponível em qualquer state (Supabase processa o link)
  if (auth.status === 'signed_out') {
    return (
      <Routes>
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Sessão existe, mas ainda não sabemos se é admin
  if (auth.isAdmin === null) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <Spinner label="Verificando permissões…" />
      </div>
    );
  }

  if (auth.isAdmin === false) {
    return <NotAuthorized email={auth.session.user.email ?? ''} />;
  }

  return (
    <Layout session={auth.session}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/practices" element={<Practices />} />
        <Route path="/practices/new" element={<PracticeEdit />} />
        <Route path="/practices/:slug" element={<PracticeEdit />} />
        <Route path="/auth/callback" element={<Navigate to="/" replace />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
